import {
  CoverageHoursRouting,
  CoverageHoursShiftBlock,
} from './useCoverageHours';

export type CoverageHoursTableRow = CoverageHoursRouting | CoverageHoursShiftBlock;

export function isCoverageHoursRouting(
  row: CoverageHoursTableRow
): row is CoverageHoursRouting {
  return 'blocks' in row;
}

export function coverageHoursSubRows(
  row: CoverageHoursTableRow
): CoverageHoursTableRow[] | undefined {
  return isCoverageHoursRouting(row) ? row.blocks : undefined;
}

export function coverageHoursRowId(row: CoverageHoursTableRow): string {
  return isCoverageHoursRouting(row) ? row.routingId : row.id;
}

export function coverageHoursRoutingsWithout(
  routings: CoverageHoursRouting[],
  removedRoutingIds: string[]
): CoverageHoursRouting[] {
  return routings.filter(
    ({ routingId }) => !removedRoutingIds.includes(routingId)
  );
}

export function isCoverageHoursPageEmptied(
  page: number,
  remainingRoutings: CoverageHoursRouting[]
): boolean {
  return page > 0 && remainingRoutings.length === 0;
}
